export const productTestIds = {
  bespokeLink: "bespoke-link",
  siteHeader: "site-header",
  addToBasketBtn: "product-page-add-to-basket-btn",
  saveToShoppingListBtn: "product-page-save-to-shopping-list-btn",
  saveToShoppingListModalSaveBtn: "save-to-shopping-list-modal-save-btn",
  productHighlightsHeadline: "product-page-highlights-headline",
  orderSummaryHeadline: "product-page-order-summary-headline",
  productSummaryPrice: "product-page-summary-price",
  productStickyBarPrice: "product-page-sticky-bar-price",
};
